module.exports = "../static/images/b82542.png";